

import { Badge } from "@/shared/ui/badge";
import { Craftsman } from "@/features/masters/types";
import {
  createGenericColumns,
  createCurrencyCell,
  createDateCell,
  createBooleanBadgeCell,
  GenericColumnConfig
} from '@/shared/components/GenericTableColumns';

/**
 * 職人テーブルのカラム設定
 */
const craftsmenColumnConfigs: GenericColumnConfig<Craftsman>[] = [
  {
    accessorKey: 'name',
    header: '氏名',
    sortable: true,
    size: 200,
  },
  {
    accessorKey: 'craftsman_type_name',
    header: '職人種別',
    size: 150,
    cell: (value) => value ? <Badge variant="outline">{value}</Badge> : '-',
  },
  {
    accessorKey: 'daily_rate',
    header: '日単価 (円)',
    sortable: true,
    headerAlign: 'right',
    cellAlign: 'right',
    size: 120,
    cell: createCurrencyCell,
  },
  {
    accessorKey: 'is_active',
    header: '在籍',
    sortable: true,
    size: 100,
    cell: createBooleanBadgeCell('在籍中', '退職', 'default', 'secondary'),
  },
  {
    accessorKey: 'created_at',
    header: '登録日時',
    sortable: true,
    size: 150,
    cell: createDateCell,
  },
];

/**
 * 職人マスタデータのカラム定義 (Generic版)
 * 元のcolumns.tsxを置き換える改良版
 */
export const columns = createGenericColumns<Craftsman>(
  craftsmenColumnConfigs,
  {
    showSelect: true,
    actionMenu: {
      showCopyId: true,
      items: [
        {
          label: '編集',
          onClick: (craftsman) => {
            // 編集処理は親コンポーネントで実装される
            console.log('Edit craftsman:', craftsman.id);
          },
        },
        {
          label: '削除',
          onClick: (craftsman) => {
            // 削除処理は親コンポーネントで実装される
            console.log('Delete craftsman:', craftsman.id);
          },
          variant: 'destructive',
          show: (craftsman) => !craftsman.is_active, // 退職者のみ削除可能
        },
      ],
    },
  }
);

/**
 * カスタムアクションメニュー付きカラムを生成する関数
 */
export function createCraftsmenColumns(actions?: {
  onEdit?: (craftsman: Craftsman) => void;
  onDelete?: (craftsman: Craftsman) => void;
}) {
  return createGenericColumns<Craftsman>(
    craftsmenColumnConfigs,
    {
      showSelect: true,
      actionMenu: {
        showCopyId: true,
        items: [
          ...(actions?.onEdit ? [{
            label: '編集',
            onClick: actions.onEdit,
          }] : []),
          ...(actions?.onDelete ? [{
            label: '削除',
            onClick: actions.onDelete,
            variant: 'destructive' as const,
            show: (craftsman: Craftsman) => !craftsman.is_active,
          }] : []),
        ],
      },
    }
  );
} 